import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const HERO_IMG = "https://images.unsplash.com/photo-1585740452884-2a29a1d21514?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
const INST_IMG = "https://images.unsplash.com/photo-1612725718815-64705bf42363?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const ORARI = "Lun–Ven 7:30–12:30 · 15:00–19:00 · Sab 8:00–13:00";
const AZIENDA = {
  ragione: "Petrol Giuly S.r.l.",
  indirizzo: "Corso Roma, 107 — 28021 Borgomanero (NO)",
  email: "petrolgiuly@gmail.com",
  pec: "petrolgiulysrl@legalmail.it",
  cu: "M5UXCR1",
  piva: "02630470033",
};

const NAV = [
  { id: "home", label: "Home" },
  { id: "chi-siamo", label: "Chi siamo" },
  { id: "stazioni", label: "Le nostre stazioni" },
  { id: "servizi", label: "Servizi" },
  { id: "collaborazioni", label: "Collaborazioni" },
  { id: "contatti", label: "Contatti" },
];

function usePublicStores() {
  const [stores, setStores] = useState([]);
  useEffect(() => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/stores`;
    fetch(url).then((r) => r.json()).then((d) => Array.isArray(d) && setStores(d)).catch(() => {});
  }, []);
  return stores;
}

function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("pg_cookie_consent")) setShow(true); }, []);
  const decide = (v) => { localStorage.setItem("pg_cookie_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-4" data-testid="cookie-banner">
      <div className="mx-auto flex max-w-4xl flex-col gap-3 rounded-xl border border-white/10 bg-[#0B1F2A] p-4 text-sm text-slate-200 shadow-2xl sm:flex-row sm:items-center sm:justify-between">
        <p className="flex-1">
          Utilizziamo cookie tecnici necessari al funzionamento del sito. Con il tuo consenso possiamo usare cookie aggiuntivi per migliorare l'esperienza.{" "}
          <span className="text-slate-400">I dettagli sono nella Cookie Policy.</span>
        </p>
        <div className="flex shrink-0 gap-2">
          <button onClick={() => decide("rifiuta")} data-testid="cookie-reject" className="rounded-lg border border-white/20 px-4 py-2 font-semibold text-slate-200 transition-colors hover:bg-white/10">Rifiuta</button>
          <button onClick={() => decide("personalizza")} className="rounded-lg border border-white/20 px-4 py-2 font-semibold text-slate-200 transition-colors hover:bg-white/10">Personalizza</button>
          <button onClick={() => decide("accetta")} data-testid="cookie-accept" className="rounded-lg bg-[#1FA37A] px-4 py-2 font-bold text-white transition-colors hover:bg-[#188a66]">Accetta</button>
        </div>
      </div>
    </div>
  );
}

function Header({ navigate }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => { setOpen(false); document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }); };
  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled ? "bg-[#0B1F2A]/95 shadow-lg backdrop-blur" : "bg-transparent"}`} data-testid="public-header">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button onClick={() => go("home")} className="flex items-center gap-3">
          <img src="/logo_icon.png" alt="Logo Petrol Giuly" className="h-10 w-10 rounded-lg" />
          <span className="font-display text-xl font-black tracking-tight text-white">PETROL GIULY</span>
        </button>
        <nav className="hidden items-center gap-1 lg:flex">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-200 transition-colors hover:text-[#1FA37A]">{n.label}</button>
          ))}
          <button onClick={() => navigate("/login")} data-testid="area-riservata-btn" className="ml-2 rounded-lg border border-[#1FA37A]/60 bg-[#1FA37A]/10 px-4 py-2 text-sm font-bold text-[#49d6aa] transition-colors hover:bg-[#1FA37A] hover:text-white">Area riservata</button>
        </nav>
        <button onClick={() => setOpen(!open)} className="text-white lg:hidden" aria-label="Menu" data-testid="public-menu-btn">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-[#0B1F2A] px-5 py-3 lg:hidden">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} className="block w-full rounded-lg px-3 py-3 text-left font-semibold text-slate-200 hover:bg-white/5">{n.label}</button>
          ))}
          <button onClick={() => navigate("/login")} className="mt-2 block w-full rounded-lg bg-[#1FA37A] px-3 py-3 text-center font-bold text-white">Area riservata</button>
        </div>
      )}
    </header>
  );
}

function Section({ id, children, className = "" }) {
  return <section id={id} className={`scroll-mt-20 px-5 py-20 sm:px-8 ${className}`}>{children}</section>;
}

function ContactForm() {
  const [form, setForm] = useState({ nome: "", email: "", telefono: "", motivo: "informazioni", messaggio: "", consenso: false, website: "" });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setState("loading");
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/contact`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form),
      });
      if (!r.ok) { const d = await r.json(); throw new Error(d.detail || "Errore"); }
      setState("done");
    } catch (e) { setErr(e.message); setState("idle"); }
  };
  if (state === "done") return (
    <div className="rounded-2xl border border-[#1FA37A]/40 bg-[#1FA37A]/10 p-8 text-center" data-testid="contact-success">
      <div className="text-2xl font-black text-[#49d6aa]">Messaggio inviato ✓</div>
      <p className="mt-2 text-slate-300">Grazie, ti risponderemo al più presto.</p>
    </div>
  );
  const F = (k, v) => setForm({ ...form, [k]: v });
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
      {err && <div className="rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-2 text-sm text-red-300" data-testid="contact-error">{err}</div>}
      <input className="hidden" value={form.website} onChange={(e) => F("website", e.target.value)} tabIndex={-1} autoComplete="off" aria-hidden />
      <div className="grid gap-4 sm:grid-cols-2">
        <input required placeholder="Nome e cognome *" value={form.nome} onChange={(e) => F("nome", e.target.value)} className="rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#1FA37A] focus:outline-none" data-testid="contact-nome" />
        <input required type="email" placeholder="Email *" value={form.email} onChange={(e) => F("email", e.target.value)} className="rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#1FA37A] focus:outline-none" data-testid="contact-email" />
        <input placeholder="Telefono (facoltativo)" value={form.telefono} onChange={(e) => F("telefono", e.target.value)} className="rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#1FA37A] focus:outline-none" data-testid="contact-telefono" />
        <select value={form.motivo} onChange={(e) => F("motivo", e.target.value)} className="rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-white focus:border-[#1FA37A] focus:outline-none" data-testid="contact-motivo">
          <option value="informazioni">Informazioni punto vendita</option>
          <option value="commerciale">Proposta commerciale</option>
          <option value="candidatura">Candidatura</option>
          <option value="fornitura">Fornitura</option>
          <option value="assistenza">Assistenza</option>
          <option value="altro">Altro</option>
        </select>
      </div>
      <textarea required rows={4} placeholder="Messaggio *" value={form.messaggio} onChange={(e) => F("messaggio", e.target.value)} className="w-full rounded-lg border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-slate-400 focus:border-[#1FA37A] focus:outline-none" data-testid="contact-messaggio" />
      <label className="flex items-start gap-2 text-sm text-slate-300">
        <input type="checkbox" checked={form.consenso} onChange={(e) => F("consenso", e.target.checked)} className="mt-1" data-testid="contact-consenso" required />
        <span>Ho letto e accetto l'informativa sulla privacy e autorizzo il trattamento dei dati per rispondere alla richiesta.</span>
      </label>
      <button disabled={state === "loading"} className="rounded-lg bg-[#1FA37A] px-6 py-3 font-bold text-white transition-colors hover:bg-[#188a66] disabled:opacity-60" data-testid="contact-submit">
        {state === "loading" ? "Invio…" : "Invia messaggio"}
      </button>
    </form>
  );
}

const SERVICES = [
  { t: "Carburanti", d: "Rifornimento efficiente e impianti curati." },
  { t: "Bar e caffetteria", d: "Pausa e accoglienza per chi viaggia." },
  { t: "Shop", d: "Prodotti e necessità quotidiane." },
  { t: "Autolavaggio", d: "Cura del veicolo in modo rapido." },
  { t: "Ricariche e pagamenti", d: "Servizi di pagamento e ricariche." },
  { t: "Assistenza al cliente", d: "Personale attento e disponibile." },
];

export default function PublicHome() {
  const navigate = useNavigate();
  const stores = usePublicStores();
  return (
    <div className="min-h-screen bg-[#0B1F2A] font-sans text-slate-100" data-testid="public-home">
      <Header navigate={navigate} />

      {/* HERO */}
      <Section id="home" className="relative flex min-h-screen items-center !py-0">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="Stazione di servizio moderna al tramonto" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B1F2A] via-[#0B1F2A]/80 to-[#0B1F2A]/35" />
        </div>
        <div className="relative mx-auto max-w-7xl pt-28">
          <p className="mb-3 font-semibold uppercase tracking-[0.3em] text-[#49d6aa]">Energia, servizi e attenzione al cliente</p>
          <h1 className="font-display text-4xl font-black leading-tight sm:text-5xl lg:text-6xl">Energia, servizio<br />e fiducia.</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-300">Petrol Giuly gestisce stazioni di servizio moderne e accoglienti, offrendo ogni giorno professionalità, efficienza e attenzione alle esigenze di chi viaggia.</p>
          <div className="mt-8 flex flex-wrap gap-4">
            <button onClick={() => document.getElementById("stazioni")?.scrollIntoView({ behavior: "smooth" })} className="rounded-lg bg-[#1FA37A] px-6 py-3.5 font-bold text-white transition-transform hover:scale-[1.03]" data-testid="hero-stazioni-btn">Scopri le nostre stazioni</button>
            <button onClick={() => document.getElementById("contatti")?.scrollIntoView({ behavior: "smooth" })} className="rounded-lg border border-white/25 px-6 py-3.5 font-bold text-white transition-colors hover:bg-white/10" data-testid="hero-contatti-btn">Contattaci</button>
          </div>
        </div>
      </Section>

      {/* CHI SIAMO */}
      <Section id="chi-siamo" className="bg-[#0E2633]">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Una gestione moderna, costruita sull'esperienza.</h2>
          <div className="mt-6 grid gap-6 lg:grid-cols-2">
            <p className="text-lg leading-relaxed text-slate-300">Petrol Giuly è una realtà specializzata nella gestione di stazioni di servizio e attività complementari. Lavoriamo quotidianamente per offrire impianti efficienti, ambienti curati e un servizio attento, rapido e professionale.</p>
            <p className="text-lg leading-relaxed text-slate-300">La nostra organizzazione integra carburanti, bar, shop, autolavaggio e servizi per la mobilità, mantenendo al centro il rapporto di fiducia con il cliente.</p>
          </div>
          <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
            {["Professionalità", "Affidabilità", "Presenza sul territorio", "Attenzione al cliente"].map((v) => (
              <div key={v} className="rounded-xl border border-white/10 bg-white/5 p-6">
                <div className="mb-2 h-1 w-10 rounded bg-[#1FA37A]" />
                <div className="font-display text-lg font-bold">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* STAZIONI */}
      <Section id="stazioni">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Le nostre stazioni</h2>
          <p className="mt-3 max-w-2xl text-slate-300">I punti vendita attualmente gestiti da Petrol Giuly.</p>
          <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {stores.length === 0 && <p className="text-slate-400">Elenco in aggiornamento.</p>}
            {stores.map((s, i) => (
              <div key={i} className="overflow-hidden rounded-2xl border border-white/10 bg-[#0E2633]" data-testid={`public-store-${i}`}>
                <div className="flex items-center justify-between border-b border-white/10 px-6 py-4">
                  <div>
                    <div className="font-display text-xl font-bold">{s.name}</div>
                    <div className="text-sm text-slate-400">{s.comune}{s.provincia ? ` (${s.provincia})` : ""}</div>
                  </div>
                  {s.brand && <span className="rounded-full bg-[#1FA37A]/15 px-3 py-1 text-xs font-bold text-[#49d6aa]">{s.brand}</span>}
                </div>
                <div className="p-6">
                  {s.types?.length > 0 ? (
                    <ul className="space-y-1.5 text-sm text-slate-300">
                      {s.types.map((t) => <li key={t} className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-[#1FA37A]" />{t}</li>)}
                    </ul>
                  ) : <p className="text-sm text-slate-400">Servizi in aggiornamento.</p>}
                  <div className="mt-4 flex items-start gap-2 text-sm text-slate-300">
                    <svg className="mt-0.5 shrink-0 text-[#49d6aa]" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                    <span>{ORARI}</span>
                  </div>
                  {s.indirizzo ? (
                    <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.name + " " + s.indirizzo)}`} target="_blank" rel="noreferrer" className="mt-5 inline-block rounded-lg border border-white/20 px-4 py-2 text-sm font-semibold text-white hover:bg-white/10">Indicazioni stradali</a>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-slate-500">Indirizzi, orari e recapiti vengono pubblicati una volta inseriti e verificati dall'amministrazione.</p>
        </div>
      </Section>

      {/* SERVIZI */}
      <Section id="servizi" className="bg-[#0E2633]">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Molto più di un rifornimento.</h2>
          <p className="mt-3 max-w-2xl text-slate-300">Le nostre stazioni sono pensate come punti di servizio completi, capaci di accompagnare il cliente nelle esigenze quotidiane della mobilità.</p>
          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <div key={s.t} className="rounded-2xl border border-white/10 bg-white/5 p-6 transition-colors hover:border-[#1FA37A]/50">
                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-[#1FA37A]/15 text-[#49d6aa]">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6 9 17l-5-5" /></svg>
                </div>
                <div className="font-display text-lg font-bold">{s.t}</div>
                <p className="mt-1 text-sm text-slate-400">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </Section>

      {/* COLLABORAZIONI */}
      <Section id="collaborazioni">
        <div className="mx-auto max-w-7xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Esperienza con grandi marchi dell'energia</h2>
          <p className="mt-3 max-w-3xl text-slate-300">Petrol Giuly opera nella gestione di stazioni di servizio con insegne Enilive e Q8, applicando elevati standard di qualità, organizzazione e attenzione al cliente.</p>
          <div className="mt-10 grid gap-6 md:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-[#0E2633] p-8">
              <div className="font-display text-2xl font-black text-[#49d6aa]">Esperienza Enilive</div>
              <p className="mt-3 text-slate-300">Gestione della stazione di servizio e delle attività dedicate all'accoglienza, al rifornimento e ai servizi per il cliente.</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-[#0E2633] p-8">
              <div className="font-display text-2xl font-black text-[#C6A15A]">Esperienza Q8</div>
              <p className="mt-3 text-slate-300">Gestione di servizi carburante e attività complementari, con particolare attenzione all'efficienza, alla cura dell'impianto e alla soddisfazione del cliente.</p>
            </div>
          </div>
          <p className="mt-6 text-sm text-slate-500">Enilive e Q8 sono marchi appartenenti ai rispettivi titolari. Petrol Giuly opera con le insegne Enilive e Q8.</p>
        </div>
      </Section>

      {/* ISTITUZIONALE */}
      <Section id="istituzionale" className="relative !py-28">
        <div className="absolute inset-0"><img src={INST_IMG} alt="Stazione di servizio di notte" className="h-full w-full object-cover" /><div className="absolute inset-0 bg-[#07161E]/90" /></div>
        <div className="relative mx-auto max-w-7xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Ogni giorno al servizio di chi viaggia.</h2>
          <p className="mt-4 max-w-3xl text-lg text-slate-300">Organizzazione, controllo, cortesia e attenzione ai dettagli sono alla base del nostro lavoro. Investiamo in processi efficienti e in servizi capaci di migliorare concretamente l'esperienza del cliente.</p>
          <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
            {["Gestione professionale", "Controllo operativo", "Cura degli spazi", "Servizi integrati"].map((v) => (
              <div key={v} className="rounded-xl border border-white/10 bg-white/5 p-6 text-center font-display font-bold">{v}</div>
            ))}
          </div>
        </div>
      </Section>

      {/* CONTATTI */}
      <Section id="contatti" className="bg-[#0E2633]">
        <div className="mx-auto max-w-6xl">
          <h2 className="font-display text-3xl font-black sm:text-4xl">Parliamo del prossimo progetto.</h2>
          <p className="mt-3 max-w-2xl text-slate-300">Per informazioni sui nostri punti vendita, sui servizi disponibili o per opportunità professionali e commerciali, contatta Petrol Giuly.</p>
          <div className="mt-10 grid gap-8 lg:grid-cols-5">
            <div className="lg:col-span-2" data-testid="contact-info">
              <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
                <div className="font-display text-xl font-bold">{AZIENDA.ragione}</div>
                <dl className="mt-4 space-y-3 text-sm">
                  <div><dt className="text-slate-400">Sede legale</dt><dd className="text-slate-200">{AZIENDA.indirizzo}</dd></div>
                  <div><dt className="text-slate-400">Email</dt><dd><a href={`mailto:${AZIENDA.email}`} className="text-[#49d6aa] hover:underline">{AZIENDA.email}</a></dd></div>
                  <div><dt className="text-slate-400">PEC</dt><dd><a href={`mailto:${AZIENDA.pec}`} className="text-[#49d6aa] hover:underline">{AZIENDA.pec}</a></dd></div>
                  <div className="flex gap-6">
                    <div><dt className="text-slate-400">Codice Univoco</dt><dd className="text-slate-200">{AZIENDA.cu}</dd></div>
                    <div><dt className="text-slate-400">P.IVA</dt><dd className="text-slate-200">{AZIENDA.piva}</dd></div>
                  </div>
                </dl>
                <div className="mt-5 rounded-lg border border-white/10 bg-[#0B1F2A] px-4 py-3 text-sm text-slate-300">
                  <span className="font-semibold text-slate-200">Orari punti vendita</span><br />{ORARI}
                </div>
              </div>
            </div>
            <div className="lg:col-span-3"><ContactForm /></div>
          </div>
        </div>
      </Section>

      {/* FOOTER */}
      <footer className="border-t border-white/10 bg-[#07161E] px-5 py-12 sm:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2"><img src="/logo_icon.png" alt="Petrol Giuly" className="h-9 w-9 rounded-lg" /><span className="font-display text-lg font-black">PETROL GIULY</span></div>
            <p className="mt-3 text-sm text-slate-400">Petrol Giuly – Energia, servizi e attenzione al cliente.</p>
          </div>
          <div>
            <div className="mb-3 font-display font-bold">Collegamenti</div>
            <ul className="space-y-2 text-sm text-slate-400">
              {NAV.map((n) => <li key={n.id}><button onClick={() => document.getElementById(n.id)?.scrollIntoView({ behavior: "smooth" })} className="hover:text-[#49d6aa]">{n.label}</button></li>)}
            </ul>
          </div>
          <div>
            <div className="mb-3 font-display font-bold">Legale</div>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Privacy Policy</li>
              <li>Cookie Policy</li>
              <li><button onClick={() => { localStorage.removeItem("pg_cookie_consent"); window.location.reload(); }} className="hover:text-[#49d6aa]">Gestione preferenze cookie</button></li>
            </ul>
          </div>
          <div>
            <div className="mb-3 font-display font-bold">Accesso</div>
            <button onClick={() => navigate("/login")} className="rounded-lg border border-[#1FA37A]/60 px-4 py-2 text-sm font-bold text-[#49d6aa] hover:bg-[#1FA37A] hover:text-white" data-testid="footer-area-riservata">Area riservata</button>
          </div>
        </div>
        <div className="mx-auto mt-10 max-w-7xl border-t border-white/10 pt-6 text-xs text-slate-500">
          <div>{AZIENDA.ragione} · {AZIENDA.indirizzo} · P.IVA {AZIENDA.piva} · {AZIENDA.email}</div>
          <div className="mt-1">Enilive e Q8 sono marchi appartenenti ai rispettivi titolari. © {new Date().getFullYear()} Petrol Giuly.</div>
        </div>
      </footer>

      <CookieBanner />
    </div>
  );
}
